<script>
const CountryListAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryList";
const CountryChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryChange";
import axios from "axios";
export default {
    data() {
        return {
            query: "",
            SelCountry: {},
            SelLevel: [],
            Keyword: "",
            LevelLabel: "",
            CountryList: [],
            LevelList: [],
            LevelMenu: false,
        };
    },
    computed: {
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
    watch: {
        SelLevel: {
            handler(val) {
                if (val.length) {
                    if (val?.length == 1) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first;
                    } else if (val?.length > 1 && val?.length < this.LevelList?.length) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first + `(+${val.length - 1} More)`;
                    } else if (val?.length == this.LevelList?.length) {
                        this.LevelLabel = "All Levels";
                    } else {
                        this.LevelLabel = this.Translation.SelectLevel;
                    }
                } else {
                    this.LevelLabel = this.Translation.SelectLevel;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        MakeSearch() {
            let Path = "https://uniapplynow.com/search/school/";
            let SelLevelIds = this.SelLevel.map((el) => el.Id).join("-");
            let query = "?CountryId=1&LevelId=" + SelLevelIds + "&Keyword=" + this.Keyword;
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetCountries() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(CountryListAPI + this.query);
            const response = request.data;
            this.CountryList = response.detail;
        },
        async GetLevels(query) {
            const request = await axios.get(CountryChangeAPI + query);
            const response = request.data;
            this.LevelList = response.detail;
        },
    },
    mounted() {
        let LatestQuery = "?ag=12496&wfid=97&CountryId=1";
        this.GetLevels(LatestQuery);

        this.GetCountries();
    },
};
</script>
<template>
    <div class="widget">
        <div class="widget-content">
            <div class="form-row">
                <div class="form-row-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64" height="64" viewBox="0,0,256,256" style="fill: #000000">
                        <g
                            fill="#b5804b"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <g transform="scale(4,4)">
                                <path
                                    d="M52,47v-39h-30v8l-4,1v-9h-2.795c-2.322,0 -4.205,1.828 -4.205,4.083v40.833c0,2.256 1.883,4.084 4.205,4.084h36.795v-4l-37,-1v-2c0,0 32,0 37,-3zM38,31h-13v-3h13zM21,22l21,-0.75v3l-21,0.75z"
                                ></path>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="dropdown w-100 pe-4" id="VDropCnt">
                    <button type="button" :class="{show: LevelMenu}" @click="LevelMenu = !LevelMenu" class="btn btn-input btn-dropdown dropdown-dark text-start" id="VDropBtn">
                        <span class="btn-input-selected text-dark" id="VDropLbl" :class="{'pe-none': !SelCountry?.Id}">{{ LevelLabel }}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-animate dropdown-menu-list w-100" :class="{show: LevelMenu}" id="VDrop">
                        <button type="button" class="btn btn-dropdown-close" data-bs-toggle="dropdown" aria-expanded="false" @click="LevelMenu = !LevelMenu">
                            <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z"
                                    fill="#333"
                                />
                            </svg>
                        </button>
                        <div class="dropdown-close-list">
                            <li v-for="(item, index) in LevelList" :key="item.Id" class="filter-checkbox-list-item form-check">
                                <input class="form-check-input" type="checkbox" :id="'lvl_' + item.Id" :value="{Name: item.Name, Id: item.Id}" v-model="SelLevel" />
                                <label class="form-check-label" :for="'lvl_' + item.Id">{{ item.Name }} ({{ item.progCount }})</label>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
            <div class="form-row">
                <div class="form-row-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64" height="64" viewBox="0 0 64 64">
                        <path
                            d="M 33 17 L 1 24 L 10.914062 28.648438 C 10.73209 31.062624 10.121346 35.757308 8 40 L 11 40 C 12.838775 36.322449 13.169629 32.284075 13.154297 29.697266 L 33 39 L 63 24 L 33 17 z M 53 33 L 33 42 L 15 34 C 15 42 18 49 18 49 C 28 49 33 56 33 56 C 33 56 38 49 49 49 C 49 49 53 42 53 33 z M 8.3417969 41.513672 C 6.1725647 41.381349 5 43.5625 5 46 C 5 51 10 52 10 52 C 10 52 9.388 50.225 11 47 C 12 45 12 43 10 42 C 9.3953125 41.69775 8.8423889 41.544208 8.3417969 41.513672 z"
                            fill="#b5804b"
                        ></path>
                    </svg>
                </div>
                <input id="searchboxText" type="text" class="form-control" :placeholder="Translation.ProgramName" v-model="Keyword" />
            </div>
        </div>
        <div class="widget-footer">
            <button type="submit" class="btn fw-500 px-4 text-center flex-grow-1" :disabled="!SelLevel?.length" @click="MakeSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search me-1 fs-9" viewBox="0 0 16 16">
                    <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                    />
                </svg>
                Explore Now
            </button>
        </div>
    </div>
</template>
